module.exports = __webpack_public_path__ + "img/link.08073268.svg";